import React, { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";

export const NavBar = () => {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (navbarRef.current && !navbarRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleNavClose = () => {
    setExpanded(false);
  };

  return (
    <>
      <Navbar
        className="fixed-top style-navbar"
        expand="xl"
        expanded={expanded}
        collapseOnSelect
        ref={navbarRef}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="navbar-brand">
            Jane Kuehn-Tucker <span className="mobile-break">Bayonne</span>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="left-navbar">
              <Nav.Link as={Link} to="/" onClick={handleNavClose}>
                Accueil
              </Nav.Link>
              <NavDropdown title="Les 4 Clés" id="spiritualite-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to="/meditation"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Méditation
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/contes-meditatifs"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                  style={{ paddingLeft: "30px" }}
                >
                  Contes Méditatifs
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/channeling"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Channeling
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/passage-d-ames"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Passage d'âme
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/accueil-nouveaux-nes"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Accueil des nouveaux-nés
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/about" onClick={handleNavClose}>
                Qui suis-je ?
              </Nav.Link>
              <NavDropdown title="Auteure" id="auteure-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to="/nouveau-livre"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Mon nouveau livre
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={Link}
                  to="/auteure"
                  className="nav-dropdown-item"
                  onClick={handleNavClose}
                >
                  Rim-La-Belle
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/musique" onClick={handleNavClose}>
                Musique
              </Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={handleNavClose}>
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};
